import React from "react";
import { DOLLARS, PERCENTAGE } from "MODULES/SalesOrders/constants";
import classNames from "classnames";

function RepairAdminChargeV2({
  repair_admin_charge_type: { input: chargeType },
  repair_administration_charge_dollars: { input: dollars },
  repair_administration_charge_percentage: { input: percentage }
}) {
  const activeClass = type =>
    classNames("btn btn-default", {
      active: chargeType.value === type
    });

  const handleChange = newVal => () => {
    if (newVal === chargeType.value) {
      chargeType.onChange(null);
      percentage.onChange(null);
      dollars.onChange(null);
    } else {
      chargeType.onChange(newVal);
      if (newVal === DOLLARS) {
        percentage.onChange(null);
      } else if (newVal === PERCENTAGE) {
        dollars.onChange(null);
      }
    }
  };

  return (
    <div className="form-group" style={{ cursor: "pointer" }}>
      <label className="control-label" htmlFor="purchase_for">
        Repair Administration Charge Type
      </label>
      <div
        id="purchase_for"
        className="btn-group btn-group-justified"
        data-toggle="buttons"
      >
        <div
          className={activeClass(PERCENTAGE)}
          onClick={handleChange(PERCENTAGE)}
          key={PERCENTAGE}
        >
          <i className="fa fa-lg fa-check-circle" />
          &nbsp;Percentage (%)
        </div>
        <div
          className={activeClass(DOLLARS)}
          onClick={handleChange(DOLLARS)}
          key={DOLLARS}
        >
          <i className="fa fa-lg fa-check-circle" />
          &nbsp;Dollars ($)
        </div>
      </div>
    </div>
  );
}

export default RepairAdminChargeV2;



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/Form/PartDetails/RepairAdminCharge.jsx